import { render, staticRenderFns } from "./reservationList.vue?vue&type=template&id=38d39066"
import script from "./reservationList.vue?vue&type=script&lang=js"
export * from "./reservationList.vue?vue&type=script&lang=js"
import style0 from "./reservationList.vue?vue&type=style&index=0&id=38d39066&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports